import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MasterTable } from "../../components/_index";
import { getQuestion } from "../../services/question.service";
import { Button, Box, Typography, debounce } from "@mui/material";
import AddClientManagement from "./AddClientManagement";
import {
  deleteClient,
  getClient,
} from "../../services/clientManagement.service";
import ConfirmBox from "../../components/ConfirmBox/ConfirmBox";
import AddIcon from "@mui/icons-material/Add";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { showToast } from "../../redux/Reducer/toastReducer";
import { useDispatch } from "react-redux";

const ClientManagement = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [tableTotalCount, setTableCount] = useState(0);
  const [selectedData, setSelectedData] = useState({});

  const [queryParam, setQueryParam] = useState({
    search: "",
    page: 1,
    limit: 10,
    sortType: "",
    sort: "",
  });

  const GetClientData = async () => {
    try {
      const res = await getClient(queryParam);
      const modifiedData =
        res?.data.map((e) => ({
          ...e,
        })) || [];
      setTableCount(res?.totalCount || 0);
      setData(modifiedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetClientData();
  }, [queryParam.page, queryParam.sort, queryParam.limit, queryParam.search]);

  const columns = [
    { id: "name", label: "Client Name" },
    { id: "contactPersonName", label: "Contact Person Name" },
    { id: "contactPersonMobile", label: "Contact Person Mobile" },
    { id: "description", label: "Description" },
  ];

  const tableOutputEvent = useCallback((params) => {
    setQueryParam((queryParams) => ({
      ...queryParams,
      ...params,
    }));
  }, []);
  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const handleAdd = () => {
    setSelectedData({});
    setOpenDrawer(true);
  };
  const handleView = (e) => {
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const handleEdit = (e) => {
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [selectedDataId, setSelectedDataId] = useState(null);

  const handleDelete = (e) => {
    setSelectedDataId(e._id);
    setConfirmDeleteOpen(true);
  };

  const deleteFunction = async () => {
    try {
      const res = await deleteClient(selectedDataId);
      setConfirmDeleteOpen(false);
      GetClientData();
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="mainContent">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Box className="SearchInputBoxContainer">
          <SearchOutlinedIcon className="Search_Icon" />
          <input
            className="SearchInputBox"
            placeholder="Search here"
            onChange={(e) => handleSearch(e.target.value)}
          />
        </Box>
        {/* <Button className="addButton" onClick={handleAdd}>
          <AddIcon />
          Add Client
        </Button> */}
      </Box>
      <MasterTable
        data={data}
        columns={columns}
        isServerSide={true}
        handleView={handleView}
        // handleEdit={handleEdit}
        // handleDelete={handleDelete}
        tableTotalCount={tableTotalCount}
        tableOutputEvent={tableOutputEvent}
      />
      {openDrawer ? (
        <AddClientManagement
          open={openDrawer}
          setOpenDrawer={setOpenDrawer}
          selectedData={selectedData}
          handleCloseDrawer={handleCloseDrawer}
          formType={selectedData._id ? "edit" : "add"}
          GetClientData={GetClientData}
        />
      ) : null}
      <ConfirmBox
        open={confirmDeleteOpen}
        title="Delete"
        content="Are you sure you want to delete?"
        confirmButton="Delete"
        setOpenConfirmBox={() => setConfirmDeleteOpen(false)}
        Function={deleteFunction}
      />
    </div>
  );
};

export default ClientManagement;
